import { render } from "./BarcodeListPage.vue?vue&type=template&id=8d1d7076&scoped=true"
import script from "./BarcodeListPage.vue?vue&type=script&lang=ts"
export * from "./BarcodeListPage.vue?vue&type=script&lang=ts"

import "./BarcodeListPage.vue?vue&type=style&index=0&id=8d1d7076&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8d1d7076"

export default script